import clsx from "clsx"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { useDebounce } from "use-lodash-debounce"

const NewSearchInput = ({ handleSearch, className, type = "doc" }) => {
  const [valueHolder, setValueHolder] = useState("")
  const debouncedSearch = useDebounce(valueHolder, 250)

  useEffect(() => {
    handleSearch(valueHolder)
  }, [debouncedSearch])

  return (
    <div
      className={clsx(
        "flex items-center bg-[white] p-4 h-full search-input rounded-lg",
        className && className,
      )}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className="w-3 h-3 mr-2"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
        />
      </svg>
      <input
        onChange={(e) => {
          setValueHolder(e.target.value)
        }}
        type="search"
        className="text-[12px]"
        placeholder={`Search ${type}`}
      />
    </div>
  )
}

NewSearchInput.propTypes = {
  handleSearch: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string,
}

export default NewSearchInput
